<template>
    <el-dialog
            title=""
            :visible.sync="show"
            width="500px"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @close="clearTimer"
            >
        <div class="qrcode-wrap" style="margin-top: -30px">
            <div class="qrcode-tip" v-if="orderWorkProcessDo"><b>{{orderWorkProcessDo.processName}}：打开始卡</b></div>
            <div class="qrcode-box">
                <img :src="base64QRCode" width="400px" height="400px" />
            </div>
            <div style="text-align: center;font-size: 20px;color: #23964d"><b>打开手机扫一扫</b></div>
        </div>

    </el-dialog>
</template>

<script>
    import {commonTriadServiceAPI} from '@/views/clockIn/http/triadApi';
    import axios from 'axios'
    export default {
        name: "clockInComponent",
        props: {

        },
        data() {
            return {
                show: false,
                base64QRCode: "",
                orderWorkProcessDo:null,

                fkOrderIds:null,
                processCode:null,

                loopTimer:null,
            }
        },
        watch: {

        },
        methods: {
            start(fkOrderIds, processCode,isEnd) {
                this.fkOrderIds = fkOrderIds
                this.processCode = processCode
                var params = {fkOrderIds: this.fkOrderIds, processCode: this.processCode}
                commonTriadServiceAPI("orderWorkProcessGetQrcode", params).then(data => {
                    if (data == null || data.qcCode == null) return this.show = false
                    this.base64QRCode = data.qcCode
                    this.orderWorkProcessDo = data.orderWorkProcessDo
                    this.show = true
                    this.onLoop(isEnd)
                })
            },
            end(fkOrderIds, processCode,isLess ) {
                this.fkOrderIds = fkOrderIds
                this.processCode = processCode
                var params = {fkOrderIds: this.fkOrderIds, processCode: this.processCode}
                if (isLess) commonTriadServiceAPI("orderWorkProcessBeforeDoneClockInService", params).then(data => {})
                else commonTriadServiceAPI("orderWorkProcessDoneClockInService", params).then(data => {
                })
            },
            onLoop(isEnd) {
                var _this = this;
                this.loopTimer = setInterval(() => {
                    var params = {fkOrderIds: _this.fkOrderIds, processCode: _this.processCode}
                    commonTriadServiceAPI("orderWorkProcessGetQrcode", params).then(data => {
                        console.log(data)
                        if (data == null || data.qcCode == null) {
                            _this.show = false
                            _this.clearTimer()
                             if (isEnd)
                                 _this.end(_this.fkOrderIds, _this.processCode)
                        }
                    })
                }, 3000)
            },
            clearTimer() {
                if (this.loopTimer) {
                    clearTimeout(this.loopTimer)
                    this.loopTimer = null
                }
            },
        }
    }
</script>

<style scoped>
    .qrcode-wrap {
        text-align: center;
    }
    .qrcode-box {
        display: inline-block;
        border: 2px solid #4078c0;
        padding:12px;
    }
    .qrcode-tip {
        margin-top:0px;
        font-size:26px;
        color:#333;
        font-weight: bold;
    }
</style>
